import { FunctionComponent } from "react";
import NAV from "../components/NAV";
const Lesson2: FunctionComponent = () => {
  return (
    <div className="relative bg-gray-100 w-full overflow-hidden flex flex-col items-center justify-center p-[2.69rem] box-border gap-[6.88rem] text-left text-[1.56rem] text-darkgray font-nunito">
      <NAV dimensionCode="/nav@2x.png" navIconFlexShrink="unset" />
      <div className="self-stretch flex flex-row items-center justify-between">
      <a className="cursor-pointer text-darkgray no-underline" href={"/lesson1"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Back
          </b>
        </div>
        </a>
        <div className="self-stretch flex-1 flex flex-col items-center justify-center text-center text-[2.81rem] text-white">
          <b className="self-stretch relative leading-[100%]">Balanced Life</b>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson3"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Next
          </b>
        </div>
        </a>
      </div>
      <div className="w-full flex flex-col items-center justify-center gap-[7.94rem] max-w-[102.63rem] text-justify text-gainsboro-100 font-dm-sans">
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.88rem]">
          <p className="m-0 text-white">
            <b>List of The Best Quality Attributes</b>
          </p>
          <p className="m-0 text-[1.56rem]">&nbsp;</p>
          <ul className="m-0 text-[1rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>Intelligence</span>
            </li>
            <li className="mb-[0rem]">
              <span>Leadership</span>
            </li>
            <li className="mb-[0rem]">
              <span>Kindness</span>
            </li>
            <li className="mb-[0rem]">
              <span>Empathy</span>
            </li>
            <li className="mb-[0rem]">
              <span>{`Reliability `}</span>
            </li>
            <li className="mb-[0rem]">
              <span>{`Innovative `}</span>
            </li>
            <li className="mb-[0rem]">
              <span>Thoughtful</span>
            </li>
            <li className="mb-[0rem]">
              <span>Effective</span>
            </li>
            <li className="mb-[0rem]">
              <span>Resilient</span>
            </li>
            <li className="mb-[0rem]">
              <span>Brave</span>
            </li>
            <li className="mb-[0rem]">
              <span>Calm</span>
            </li>
            <li>
              <span>Optimistic</span>
            </li>
          </ul>
        </div>
        <img
          className="relative w-[58.25rem] h-[30.5rem] object-cover"
          alt=""
          src="/2@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0 text-[1.88rem] text-white">
            <b>Basic needs by Tony Robbins</b>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Everyone has their own desires, their own dreams, and their own way
            of thinking. But however different we all seem to be, in essence, we
            have the same basic needs. Tony Robbins, the world-renowned
            inspirer, life coach, and speaker on the field of personal
            development, names the six needs every human being has as follows:
          </p>
          <p className="m-0">&nbsp;</p>
          <ul className="m-0 text-[1rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>Certainty, because we want a carefree existence.</span>
            </li>
            <li className="mb-[0rem]">
              <span>Variety, because too much certainty gets boring.</span>
            </li>
            <li className="mb-[0rem]">
              <span>Sight, because we want to be seen and heard.</span>
            </li>
            <li className="mb-[0rem]">
              <span>
                Love and connectedness, because otherwise, we feel lonely.
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                Growth, because development leads to fulfillment and happiness.
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                Contribution to others or society, because we want to be
                meaningful.
              </span>
            </li>
          </ul>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            If you combine your personal values with the six basic needs and add
            to them your limiting beliefs, you will be able to explain much of
            your behavior. Then you will understand how your mindset came about,
            and that this gives you the key to accessing your most beautiful
            life.
          </p>
        </div>
        <b className="self-stretch relative text-[2.19rem] tracking-[0.02em] leading-[2rem] text-white text-center">
          Terence McKenna
        </b>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            “You have to take seriously the notion that understanding the
            universe is your responsibility, because the only understanding of
            the universe that will be useful to you is your own understanding.”
          </p>
          <p className="m-0">&nbsp;</p>
          <ul className="m-0 font-inherit text-inherit pl-[1.32rem]">
            <li className="mb-[false]">
              Expand Your Mind: Open-mindedness is the key to expanding your
              consciousness. Embrace new ideas, cultures, and perspectives. Read
              widely, engage in conversations with diverse people, and be
              receptive to fresh insights.
            </li>
            <li className="mb-[false]">
              Feed Your Curiosity: Cultivate your curiosity like a precious
              garden. Ask questions, explore your interests, and seek knowledge
              relentlessly. The pursuit of curiosity can lead to profound
              discoveries about the world and yourself.
            </li>
            <li className="mb-[false]">
              Practice Empathy: Develop your empathy by genuinely understanding
              and sharing in the feelings of others. Put yourself in their
              shoes, listen actively, and offer support. Compassion can lead to
              deeper and more meaningful connections with those around you.
            </li>
            <li className="mb-[false]">
              Be Authentic: Living authentically means being true to yourself.
              Don't conform to societal expectations that don't align with your
              values. Express your uniqueness boldly and unapologetically.
            </li>
            <li className="mb-[false]">
              Embrace Courage: Confront your fears and step into the unknown.
              Courage allows you to break free from comfort zones and embark on
              transformative journeys. Don't let fear hold you back from your
              potential.
            </li>
            <li className="mb-[false]">
              Cultivate Gratitude: Find joy in the simple pleasures of life and
              express gratitude for them. Keep a gratitude journal to remind
              yourself of the beauty in everyday experiences. Gratitude enhances
              your overall well-being.
            </li>
            <li className="mb-[false]">
              Recognize Connectedness: Understand your interconnectedness with
              all living beings and the universe. Treat others and the world
              with care and respect, knowing that your actions have a ripple
              effect.
            </li>
            <li className="mb-[false]">
              Set Intention: Before starting your day, set an intention to
              embody these qualities. Reflect on how you can incorporate
              open-mindedness, curiosity, empathy, authenticity, courage,
              gratitude, and connectedness into your daily life.
            </li>
            <li className="mb-[false]">
              Mindfulness Practice: Engage in mindfulness exercises to stay
              present in the moment. Regular meditation or deep-breathing
              exercises can help you remain grounded and focused on your
              personal growth.
            </li>
            <li>
              Seek Inspiration: Read the works of philosophical thinkers like
              Terence McKenna, listen to their talks, and find inspiration to
              fuel your journey towards a more meaningful and enlightened life.
            </li>
          </ul>
        </div>
      </div>
      <a className="cursor-pointer text-darkgray no-underline" href={"/lesson3"}>
        <div className="rounded-32xl bg-gainsboro-200 box-border w-[25rem] flex flex-col items-center justify-center pt-[0.69rem] px-[3rem] pb-[1rem] max-w-[31.25rem] text-center text-[1.88rem] border-[1px] border-solid border-gray-300">
          <b className="self-stretch relative">Next Chapter</b>
        </div>
      </a>
    </div>
  );
};

export default Lesson2;
